import State from '../core/State';
import initialState from '../initialState';
import produce, { Draft } from 'immer';

export const setSelectedChartGroup = (data: number) =>
  produce((draft: Draft<State>) => {
    draft.selectedChartGroup.data = data;
  });

export const dispose = () =>
  produce((draft: Draft<State>) => {
    draft.selectedChartGroup = initialState.selectedChartGroup;
  });
